// Browser stub for sanitize-html.
//
// react-jhipster's Translate component (translate.tsx) imports
// `import * as sanitizeHtml from 'sanitize-html'`. The real sanitize-html
// pulls in postcss → source-map-js / fs / path / url — all Node-only, all
// produce "Module ... has been externalized for browser compatibility"
// warnings under Vite dev.
//
// TAMAM only imports `Storage` and `isPromise` from react-jhipster, NEVER
// the Translate component. Aliasing sanitize-html → this stub (via
// vite.config.ts resolve.alias) breaks the postcss chain entirely while
// preserving behavior for our actual usage.
//
// If anything ever does call Translate, the stub returns the input string
// unchanged — i.e. no sanitization. That would only be a problem if a
// translation key contained HTML attempting injection, which our codebase
// doesn't do (we render via <I18n /> with plain strings).
const sanitizeHtml = (input) => (input == null ? '' : String(input));
sanitizeHtml.defaults = { allowedTags: [], allowedAttributes: {} };
sanitizeHtml.simpleTransform = () => () => undefined;
export default sanitizeHtml;
